import PropTypes from 'prop-types';
import React from 'react';
import {
  ChartContainer,
  ChartText,
  CircleBackground,
  CircleChart,
  CircleForeground,
  getDefaultStrokeColor,
} from './Styles';

export const AnimatedCircleChart = ({
  bgColor,
  bottomText,
  error,
  onClick,
  settings,
  topText,
  value,
}) => {
  const chartSettings =
    settings ||
    defaultCircleChartSettings({
      bgColor,
      bottomText,
      error,
      topText,
      value,
    });

  const {
    bottomTextYPos,
    hasBottomText,
    hasTopText,
    maxPercent,
    path,
    size,
    strokeBgColor,
    strokeColor,
    textColor,
    topTextYPos,
    xMove,
  } = chartSettings;

  return (
    <ChartContainer onClick={() => onClick({ value })}>
      <CircleChart size={size} viewBox={`0 0 ${xMove * 2} ${xMove * 2}`}>
        <CircleBackground bgColor={strokeBgColor} d={path} />
        <CircleForeground
          d={path}
          percent={value}
          strokeColor={strokeColor}
          strokeDasharray={`${value}, ${maxPercent}`}
        />
        {hasTopText && (
          <ChartText color={textColor} x={xMove} y={topTextYPos}>
            {topText}
          </ChartText>
        )}
        {hasBottomText && (
          <ChartText color={textColor} x={xMove} y={bottomTextYPos}>
            {bottomText}
          </ChartText>
        )}
      </CircleChart>
    </ChartContainer>
  );
};

AnimatedCircleChart.propTypes = {
  bgColor: PropTypes.string,
  bottomText: PropTypes.string,
  error: PropTypes.bool,
  onClick: PropTypes.func,
  settings: PropTypes.func,
  topText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

AnimatedCircleChart.defaultProps = {
  bgColor: '',
  bottomText: null,
  error: false,
  topText: null,
  value: 0,
  onClick: () => null,
};

const defaultCircleChartSettings = (
  { bgColor = null, bottomText = '', error = false, topText = '', value = 0 },
  strokeColors = getDefaultStrokeColor,
) => {
  const maxPercent = 100;
  const diameter = 15.9155;
  const xMove = 18;
  const yMove = 2.0845;
  const circlePath = `
    M ${xMove} ${yMove}
    a ${diameter} ${diameter} 0 0 1 0 ${diameter * 2}
    a ${diameter} ${diameter} 0 0 1 0 -${diameter * 2}
  `;

  const hasTopText = topText !== '';
  const hasBottomText = bottomText !== '';

  const topTextYPos = hasBottomText ? 15.35 : 19;
  const bottomTextYPos = 22.35;

  return {
    bottomTextYPos,
    hasBottomText,
    hasTopText,
    maxPercent,
    path: circlePath,
    size: '125px',
    strokeBgColor: '#eee',
    strokeColor: strokeColors(bgColor, value, error),
    textColor: '#666',
    topTextYPos,
    xMove,
  };
};
